const location = (() => {
  if (document.querySelector("body#pageLocation") !== null) {



    let sW = window.innerWidth;

    {
      let setSpeed = 40000

      $('#jsSecLoc .js-slider').slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: setSpeed,
        cssEase: "linear",
        slidesToShow: 1,
        arrows: false,
        variableWidth: true,
      });

      $('#jsSecFoo .js-slider').slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: setSpeed,
        cssEase: "linear",
        slidesToShow: 1,
        arrows: false,
        variableWidth: true,
        rtl: true,
      });
    }



  }
})()
export default location;